import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
import { Button } from './ui/Button';
export function ContactForm() {
  const [formState, setFormState] = useState({
    fullName: '',
    nationality: '',
    email: '',
    telephone: '',
    message: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    setTimeout(() => {
      setStatus('success');
      setFormState({
        fullName: '',
        nationality: '',
        email: '',
        telephone: '',
        message: ''
      });
      setTimeout(() => setStatus('idle'), 3000);
    }, 1500);
  };
  return <motion.div initial={{
    opacity: 0,
    x: 20
  }} whileInView={{
    opacity: 1,
    x: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="bg-white rounded-2xl shadow-xl p-8 md:p-10" data-id="element-39">
      <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-40">
        Send us a Message
      </h3>

      {status === 'success' && <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-green-50 border border-green-200 rounded-xl p-4 mb-6 flex items-center gap-3" data-id="element-41">
          <CheckCircle className="text-green-600" size={24} data-id="element-42" />
          <p className="text-green-800 font-medium" data-id="element-43">
            Message sent successfully! We'll get back to you soon.
          </p>
        </motion.div>}

      <form onSubmit={handleSubmit} className="space-y-5" data-id="element-44">
        <div className="space-y-2" data-id="element-45">
          <label htmlFor="fullName" className="text-sm font-semibold text-gray-700" data-id="element-46">
            Full Name *
          </label>
          <input type="text" id="fullName" name="fullName" required value={formState.fullName} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0066FF] focus:border-transparent outline-none transition-all" placeholder="Enter your full name" data-id="element-47" />
        </div>

        <div className="space-y-2" data-id="element-48">
          <label htmlFor="nationality" className="text-sm font-semibold text-gray-700" data-id="element-49">
            Nationality *
          </label>
          <input type="text" id="nationality" name="nationality" required value={formState.nationality} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0066FF] focus:border-transparent outline-none transition-all" placeholder="Enter your nationality" data-id="element-50" />
        </div>

        <div className="space-y-2" data-id="element-51">
          <label htmlFor="email" className="text-sm font-semibold text-gray-700" data-id="element-52">
            Email Address *
          </label>
          <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0066FF] focus:border-transparent outline-none transition-all" placeholder="your.email@example.com" data-id="element-53" />
        </div>

        <div className="space-y-2" data-id="element-54">
          <label htmlFor="telephone" className="text-sm font-semibold text-gray-700" data-id="element-55">
            Telephone *
          </label>
          <input type="tel" id="telephone" name="telephone" required value={formState.telephone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0066FF] focus:border-transparent outline-none transition-all" placeholder="+1 (555) 000-0000" data-id="element-56" />
        </div>

        <div className="space-y-2" data-id="element-57">
          <label htmlFor="message" className="text-sm font-semibold text-gray-700" data-id="element-58">
            Message *
          </label>
          <textarea id="message" name="message" required rows={6} value={formState.message} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-[#0066FF] focus:border-transparent outline-none transition-all resize-none" placeholder="Tell us about your inquiry..." data-id="element-59" />
        </div>

        <Button type="submit" variant="primary" className="w-full justify-center py-4 text-lg" disabled={status === 'submitting'} data-id="element-60">
          {status === 'submitting' ? <span className="flex items-center gap-2" data-id="element-61">
              <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-62">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-63"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-64"></path>
              </svg>
              Sending...
            </span> : <span className="flex items-center gap-2" data-id="element-65">
              Submit <Send size={18} data-id="element-66" />
            </span>}
        </Button>
      </form>
    </motion.div>;
}